// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.features-section {
  background-color: #f8fafc; /* Очень светло-серый фон для контраста с Hero */
  padding: 100px 20px;
  font-family: 'Poppins', sans-serif;
  position: relative;
  overflow: hidden;
}

.features-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Заголовок секции */
.features-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
}

.brand-highlight {
  color: #2563eb; /* Королевский синий */
}

.section-subtitle {
  font-size: 16px;
  color: #64748b;
  line-height: 1.6;
}

/* Сетка */
.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 колонки */
  gap: 30px;
}

/* Карточка */
.feature-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 1;
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px -5px rgba(0, 0, 0, 0.1);
  border-color: transparent;
}

/* Иконка */
.icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.icon-wrapper svg {
  width: 32px;
  height: 32px;
  stroke-width: 2px;
}

/* Тексты */
.feature-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}

.feature-text {
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

/* Цветовые темы для карточек */
/* Blue Theme */
.feature-card.blue .icon-wrapper {
  background: #eff6ff;
  color: #2563eb;
}
.feature-card.blue:hover { border-bottom: 4px solid #2563eb; }

/* Orange Theme */
.feature-card.orange .icon-wrapper {
  background: #fff7ed;
  color: #f59e0b;
}
.feature-card.orange:hover { border-bottom: 4px solid #f59e0b; }

/* Teal Theme */
.feature-card.teal .icon-wrapper {
  background: #f0fdfa;
  color: #0d9488;
}
.feature-card.teal:hover { border-bottom: 4px solid #0d9488; }

/* Indigo Theme */
.feature-card.indigo .icon-wrapper {
  background: #eef2ff;
  color: #4f46e5;
}
.feature-card.indigo:hover { border-bottom: 4px solid #4f46e5; }

/* Декоративный фон при ховере */
.card-bg-decoration {
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.05) 0%, transparent 70%);
  border-radius: 0 0 0 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
  pointer-events: none;
}

.feature-card:hover .card-bg-decoration {
  opacity: 1;
}

/* --- Адаптивность --- */

/* Планшеты (до 1024px) */
@media (max-width: 1024px) {
  .features-section {
    padding: 80px 20px;
  }
  .feature-card {
    padding: 30px;
  }
}

@media (max-width: 768px) {  
  .features-grid {    
    grid-template-columns: 1fr; /* Одна колонка */  
      gap: 20px;  }  
        .section-title {   
           font-size: 28px;
            }  
             .features-header { 
                 margin-bottom: 40px; 
                 }   
                  .feature-card {  
                    align-items: center; /* Центрируем контент на мобилке */    
                    text-align: center;  }    .feature-card:hover {    transform: translateY(-5px); /* Чуть меньше подъем на таче */  }
  }`, "",{"version":3,"sources":["webpack://./src/style/Features.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB,EAAE,gDAAgD;EAC3E,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS;AACX;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,+BAA+B;AAC/B,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,2BAA2B,gCAAgC,EAAE;;AAE7D,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,6BAA6B,gCAAgC,EAAE;;AAE/D,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,2BAA2B,gCAAgC,EAAE;;AAE7D,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,6BAA6B,gCAAgC,EAAE;;AAE/D,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,yBAAyB;EACzB,UAAU;EACV,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;;AAEzB,yBAAyB;AACzB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B,EAAE,iBAAiB;MAC3C,SAAS,GAAG;QACV;WACG,eAAe;YACd;aACC;iBACI,mBAAmB;iBACnB;kBACC;oBACE,mBAAmB,EAAE,kCAAkC;oBACvD,kBAAkB,GAAG,KAAK,yBAAyB,2BAA2B,EAAE,+BAA+B,GAAG;EACpI","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');\n\n.features-section {\n  background-color: #f8fafc; /* Очень светло-серый фон для контраста с Hero */\n  padding: 100px 20px;\n  font-family: 'Poppins', sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n.features-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Заголовок секции */\n.features-header {\n  text-align: center;\n  margin-bottom: 60px;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.section-title {\n  font-size: 36px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 16px;\n}\n\n.brand-highlight {\n  color: #2563eb; /* Королевский синий */\n}\n\n.section-subtitle {\n  font-size: 16px;\n  color: #64748b;\n  line-height: 1.6;\n}\n\n/* Сетка */\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 2 колонки */\n  gap: 30px;\n}\n\n/* Карточка */\n.feature-card {\n  background: #ffffff;\n  border-radius: 24px;\n  padding: 40px;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  z-index: 1;\n}\n\n.feature-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px -5px rgba(0, 0, 0, 0.1);\n  border-color: transparent;\n}\n\n/* Иконка */\n.icon-wrapper {\n  width: 60px;\n  height: 60px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  transition: all 0.3s ease;\n}\n\n.icon-wrapper svg {\n  width: 32px;\n  height: 32px;\n  stroke-width: 2px;\n}\n\n/* Тексты */\n.feature-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 12px;\n}\n\n.feature-text {\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Цветовые темы для карточек */\n/* Blue Theme */\n.feature-card.blue .icon-wrapper {\n  background: #eff6ff;\n  color: #2563eb;\n}\n.feature-card.blue:hover { border-bottom: 4px solid #2563eb; }\n\n/* Orange Theme */\n.feature-card.orange .icon-wrapper {\n  background: #fff7ed;\n  color: #f59e0b;\n}\n.feature-card.orange:hover { border-bottom: 4px solid #f59e0b; }\n\n/* Teal Theme */\n.feature-card.teal .icon-wrapper {\n  background: #f0fdfa;\n  color: #0d9488;\n}\n.feature-card.teal:hover { border-bottom: 4px solid #0d9488; }\n\n/* Indigo Theme */\n.feature-card.indigo .icon-wrapper {\n  background: #eef2ff;\n  color: #4f46e5;\n}\n.feature-card.indigo:hover { border-bottom: 4px solid #4f46e5; }\n\n/* Декоративный фон при ховере */\n.card-bg-decoration {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 150px;\n  height: 150px;\n  background: radial-gradient(circle, rgba(37, 99, 235, 0.05) 0%, transparent 70%);\n  border-radius: 0 0 0 100%;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.feature-card:hover .card-bg-decoration {\n  opacity: 1;\n}\n\n/* --- Адаптивность --- */\n\n/* Планшеты (до 1024px) */\n@media (max-width: 1024px) {\n  .features-section {\n    padding: 80px 20px;\n  }\n  .feature-card {\n    padding: 30px;\n  }\n}\n\n@media (max-width: 768px) {  \n  .features-grid {    \n    grid-template-columns: 1fr; /* Одна колонка */  \n      gap: 20px;  }  \n        .section-title {   \n           font-size: 28px;\n            }  \n             .features-header { \n                 margin-bottom: 40px; \n                 }   \n                  .feature-card {  \n                    align-items: center; /* Центрируем контент на мобилке */    \n                    text-align: center;  }    .feature-card:hover {    transform: translateY(-5px); /* Чуть меньше подъем на таче */  }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
